import React, { useEffect, useState } from 'react';
import PositionLedger from './PositionLedger';
import Scanner from './Scanner';
import PositionDetail from './PositionDetail';
import History from './History';
import Settings from './Settings';
import './App.css';

export default function App() {
  const [tab, setTab] = useState('ledger');
  const [selectedPositionId, setSelectedPositionId] = useState(null);
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    fetch('/auth/me', { credentials: 'include' })
      .then(r => r.json())
      .then(data => { setUser(data.user); setAuthLoading(false); })
      .catch(() => setAuthLoading(false));
  }, []);

  if (authLoading) {
    return <div style={{ background: '#141920', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b', fontSize: 15 }}>Loading...</div>;
  }

  if (!user) {
    return (
      <div style={{ background: '#141920', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 13, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 16 }}>Wheel Strategy</div>
          <div style={{ fontSize: 28, fontWeight: 500, color: '#f1f5f9', marginBottom: 8 }}>Decision Engine</div>
          <div style={{ fontSize: 15, color: '#64748b', marginBottom: 40 }}>Personal options trading system</div>
          <button onClick={() => { window.location.href = '/auth/google'; }} style={{ background: '#2563eb', color: '#f1f5f9', fontSize: 15, fontWeight: 500, padding: '13px 32px', borderRadius: 8, border: 'none', cursor: 'pointer' }}>
            Sign in with Google
          </button>
        </div>
      </div>
    );
  }

  if (selectedPositionId) {
    return (
      <div className="app">
        <PositionDetail positionId={selectedPositionId} onBack={() => setSelectedPositionId(null)} />
      </div>
    );
  }

  return (
    <div className="app">
      <nav className="app-nav">
        <button className={`nav-btn${tab === 'ledger' ? ' active' : ''}`} onClick={() => setTab('ledger')}>Ledger</button>
        <button className={`nav-btn${tab === 'scanner' ? ' active' : ''}`} onClick={() => setTab('scanner')}>Scanner</button>
        <button className={`nav-btn${tab === 'history' ? ' active' : ''}`} onClick={() => setTab('history')}>History</button>
        <button className={`nav-btn${tab === 'settings' ? ' active' : ''}`} onClick={() => setTab('settings')}>Settings</button>
        <button onClick={() => { window.location.href = '/auth/logout'; }} style={{ marginLeft: 'auto', fontSize: 13, color: '#475569', background: 'none', border: 'none', cursor: 'pointer', padding: '4px 0' }}>Sign out</button>
      </nav>
      <main className="main-content">
        {tab === 'ledger' && <PositionLedger onSelectPosition={(id) => setSelectedPositionId(id)} />}
        {tab === 'scanner' && <Scanner />}
        {tab === 'history' && <History />}
        {tab === 'settings' && <Settings />}
      </main>
    </div>
  );
}
